import { defineStore } from 'pinia'
import * as Sentry from "@sentry/vue";

export const mainStore = defineStore({
  id: 'main',
  persist: true,
  state: () => ({
    user: null,
    utms: {},

    idLanding: null,
    campaign: null,
    participation: null,
    participationCodes: null,
    optin_variant: null,

    products: null,
    cart: [],

    order: null,

    isPayed: false,
    isCancel: false,
    isPreview: false,
    recall2: false,

    genders: null,
    campaign: null,
    messageError: 'Lien non valide',

    genderGet: null,
    emailGet: null,
    firstnameGet: null,
    lastnameGet: null,
    dateofbirthGet: null,
    zipcodeGet: null,
    phoneGet: null,

    isWinnersModal: false,
    isReglementModal: false,
    reglementModalTitle: '',
    reglementModalMessage: '',
    reglementModalImg: '',

    // Wheel winner data
    wheelWinner: null, // { token, email, voucher, isWinner }
    isWheelWinner: false,
  }),
  getters: {
    template: (state) => state.campaign?.template ?? null,
    mecanic: (state) => state.campaign?.campaign_mecanic_data ?? null,
    campaignCode: (state) => state.campaign.campaignCode,
    participationCode1: (state) =>
      state.participationCodes?.find((c) => c.rank === 0) ?? null,
    participationCode2: (state) =>
      state.participationCodes?.find((c) => c.rank === 1) ?? null,
    optinVariant: (state) => state.optin_variant ?? null,
    // Getter pour savoir si c'est une mécanique wheel
    isWheelMechanic: (state) => state.campaign?.template?.campaign_template_mechanic_id === 5,
    // Getter pour le voucher du winner
    winnerVoucher: (state) => state.wheelWinner?.voucher ?? null,
    // Getter pour la réduction voucher
    voucherDiscount: (state) => state.wheelWinner?.voucher?.value ?? 0,
    cartProducts: (state) => {
      return (
        state.cart?.map((item) => {
          const product = state.products.find((p) => p.id === item.id)
          if (product) {
            product.quantity = item.quantity
            return product
          }
        }) ?? []
      )
    },
    getProductById: (state) => {
      return (productId) => state.products.find((p) => p.id === productId)
    },
  },
  actions: {
    setMessageError(data) {
      this.messageError = data
    },

    setUser(data) {
      this.user = data
      if (data?.email && data?.id) {
        Sentry.setUser({ id: data.id, email: data.email });
      }
    },

    setCampaign(campaign) {
      this.campaign = campaign
    },
    setParticipation(participation) {
      this.participation = participation
    },
    setParticipationCodes(codes) {
      this.participationCodes = codes
    },
    setOptinVariant(optin_variant) {
      this.optin_variant = optin_variant
    },

    setProducts(data) {
      this.products = data
    },

    addToCart(item) {
      const index = this.cart.findIndex((p) => p.id === item.id)
      if (index !== -1) {
        this.cart.splice(index, 1)
      }
      this.cart.push(item)
    },
    removeFromCart(id) {
      const index = this.cart.findIndex((p) => p.id === id)
      if (index !== -1) {
        this.cart.splice(index, 1)
      }
    },
    updateCart(cart) {
      this.cart = cart ?? []
    },

    setOrder(data) {
      this.order = data
    },
    setIsPayed(data) {
      this.isPayed = data
    },
    setIsCancel(data) {
      this.isCancel = data
    },

    setGenders(data) {
      this.genders = data
    },

    setWinnersModal(data) {
      this.isWinnersModal = data
    },

    setReglementModal(data, payload = {}) {
      this.isReglementModal = data
      if (data) {
        this.reglementModalTitle = payload.title ?? this.reglementModalTitle
        this.reglementModalMessage = payload.message ?? this.reglementModalMessage
        this.reglementModalImg = payload.img ?? this.reglementModalImg
        return
      }

      this.reglementModalTitle = ''
      this.reglementModalMessage = ''
      this.reglementModalImg = ''
    },

    closeReglementModal() {
      this.setReglementModal(false)
    },

    // Wheel winner actions
    setWinnerData(data) {
      this.wheelWinner = data
      this.isWheelWinner = data?.isWinner ?? false
    },
    clearWinnerData() {
      this.wheelWinner = null
      this.isWheelWinner = false
    },
  }
})
